<template>
  <div>
    <el-dialog v-model="dialogTableVisible" title="编辑员工信息" width="500">
      <el-form :model="form">
        <el-form-item label="企微ID" :label-width="formLabelWidth">
          <el-input disabled v-model="form.wx_user_id" autocomplete="off" />
        </el-form-item>
        <el-form-item label="姓名" :label-width="formLabelWidth">
          <el-input v-model="form.full_name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="手机号" :label-width="formLabelWidth">
          <el-input v-model="form.phone" autocomplete="off" />
        </el-form-item>
        <el-form-item label="邮箱" :label-width="formLabelWidth">
          <el-input v-model="form.email" autocomplete="off" />
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click.stop="handleClick">取消</el-button>
          <el-button type="primary" @click.stop="onsubmit()">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script >
import {ElDialog, ElForm, ElFormItem, ElInput, ElButton, ElMessage} from "element-plus";
import http from "@/utils/requset";
import {isValidEmail} from "@/../public/js/index"
export default {
  name: "UserEdit",
  components:{
    ElDialog,ElForm,ElFormItem,ElInput ,ElButton
  },
  data(){
    return{
      formLabelWidth:140,
      form:{},
      dialogTableVisible:false
    }
  },
  methods:{
    openEdit(data){
      console.log(data)
      this.dialogTableVisible=true;
      this.form = data
    },
    handleClick(){
      this.dialogTableVisible=false
      this.$emit('closeEdit',this.dialogTableVisible)
    },
    onsubmit(){
      if(!this.form.full_name){
        ElMessage.warning('请填写姓名');
        return
      }
      if(this.form.email && !isValidEmail(this.form.email)){
        ElMessage.warning('请填写正确的邮箱');
        return
      }
      http.post('/updateUser',this.form).then(()=>{
        this.dialogTableVisible=false
        this.$emit('closeEdit')
      }).catch(err=>{
        console.log(err)
      })
    }
  },
  beforeMount() {
    this.dialogTableVisible = this.dialogFormVisible
    this.form = this.member
  }
}
</script>
<style scoped>

</style>